

import {Vue, Component, Prop} from "vue-property-decorator";
import {getUsers} from "@pazion/pazion-core/src/services/auth-service";
import {UserProfile} from "@pazion/pazion-core/src/models/user-models";
import {DataTableHeader} from "vuetify";
import PazClipboardButton from "@pazion/pazion-core/src/components/controls/PazClipboardButton.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";
import PazTextSearch from "@pazion/pazion-core/src/components/controls/PazTextSearch.vue";
import PazAjaxTable from "@pazion/pazion-core/src/components/layout/PazAjaxTable.vue";
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";

@Component({
  components: {
    PazClipboardButton,
    PazTooltipButton,
    PazConfirmation,
    PazTextSearch,
    PazAjaxTable,
    PazRefreshButton,
  },
})
export default class UserMemberOfList extends Vue {

  public $userfieldSalutation!: boolean;
  public $userfieldFirstName!: boolean;
  public loading: boolean = true;
  public items: object[] = [];

  public members: Array<number> = [];

  @Prop({default: () => []})
  public initalSelection!: Array<UserProfile>;

  public search: string = "";
  public actionPending: boolean = false;

  public headers: DataTableHeader[] = [];

  get useFirstName() {
    return this.$userfieldFirstName;
  }

  $refs!: {
    confirm: PazConfirmation;
    response: PazConfirmation;
    confirmWarn: PazConfirmation;
  };


  public membersOnly: boolean = false;

  created() {
    this.headers = [
      {
        text: "Member",
        align: "start",
        sortable: true,
        value: "member",
      },
      {
        text: "username(email)",
        align: "start",
        sortable: true,
        value: "username",
      }];
    if (this.$userfieldSalutation) {
      this.headers.push(
          {
            text: "Salutation",
            align: "start",
            sortable: true,
            value: "salutation",
          }
      );
    }
    this.headers.push(
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name"
        });
    if (this.$userfieldFirstName) {
      this.headers.push(
          {
            text: "Firstname",
            align: "start",
            sortable: true,
            value: "lastName",
          }
      );
    }

    this.headers.push({
      text: "Action",
      align: "end",
      sortable: true,
      value: "extra",
    });

  }

  get filteredItems() {
    if (this.membersOnly) {
      return this.items.filter(member => {
        return this.members.includes(member.id);
      });
    }
    return this.items;
  }

  public isMember(item: any) {
    return this.members.includes(item.id);
  }

  async fetchData() {
    this.loading = true;
    this.items = await getUsers();
    this.loading = false;
  }

  async addToGroup(id: number) {
    this.actionPending = true;
    this.$emit('addMember', id, (success: boolean) => {
      if (success) {
        this.members.push(id);
      }
      this.actionPending = false;
    });
  }

  async removeFromGroup(id: number) {
    this.actionPending = true;
    this.$emit('removeMember', id, (success: boolean) => {
      if (success) {
        const index = this.members.indexOf(id, 0);
        if (index > -1) {
          this.members.splice(index, 1);
        }
      }
      this.actionPending = false;
    });
  }

  public mounted() {
    this.members = [];
    this.initalSelection.forEach(item => {
      this.members.push(item.id);
    });
    this.fetchData();
  }
}
